import Switch, { SwitchProps } from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';


interface props extends SwitchProps {
    onChange?: (event: any) => void,
    name: string,
    label: string,
    disable?: boolean,
    control: any,
    paddingtop?: number,
    labelPlacement?: "start" | "end" | "top" | "bottom"
}
//Acima: Se label placement = top, substitui o label padrao do componente pelo <label> padrao do aviso embarque.
// Isso tambem coloca o labelPlacement do switch para "end" automaticamente, para que ele fique alinhado a esquerda


const SwitchUI = (props: props)  =>{    
    // const {
    //     control
    // } = useFormContext();

    return (
        <FormControl disabled={props.disable} component="fieldset">
            <FormGroup style={{ paddingTop: props.paddingtop ? props.paddingtop : 20 }}>
                <FormControlLabel
                    disabled={props.disable}
                    name={props.name}
                    control={
                        <Controller
                            name={props.name}
                            control={props.control}
                            render={({ field }) => (
                                <>
                                    {props.labelPlacement === "top" &&
                                    <label htmlFor={field.name} className='MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink'
                                        style={{ minWidth: 0, marginTop: 9, whiteSpace: 'nowrap'}}>{props.label}</label>}

                                    <Switch {...props}
                                        checked={field.value} 
                                        color="primary" 
                                        onChange={(e) => {
                                            if (props.onChange){
                                                props.onChange(e)
                                            }
                                            field.onChange(e.target.checked)
                                        }}
                                    />
                                </>
                            )}
                        />                            
                    }
                    label={props.labelPlacement === "top" ? "" : props.label}
                    labelPlacement={props.labelPlacement === "top" ? "end" : props.labelPlacement}
                />
            </FormGroup>
        </FormControl>
    );
}


export { SwitchUI as Switch }